export default __webpack_public_path__ + "static/media/burj.00337842.jpeg";